// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__34E2G","inner":"Footer_inner__3I_R_"};